module.exports = __webpack_public_path__ + "static/media/FC_off.e3e4468a.svg";